import _toConsumableArray from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _classCallCheck from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _defineProperty from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/defineProperty";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { BadInputError, Entity, Guard, NotFoundError, Result } from '@digibricks/domains';
import { QuestionType } from '../question-type';
import { File } from '../file';
import MarkdownIt from 'markdown-it';
import { AudioFile } from '../audio-file';
import { PreviousQuestionId } from '../previous-question-id';
import { Score } from '../score';
export var QuestionStatus;

(function (QuestionStatus) {
  QuestionStatus["New"] = "New";
  QuestionStatus["ChangeNewType"] = "ChangeNewType";
  QuestionStatus["Activate"] = "Activate";
  QuestionStatus["Deactivate"] = "Deactivate";
})(QuestionStatus || (QuestionStatus = {}));

export var Question = /*#__PURE__*/function (_Entity) {
  _inherits(Question, _Entity);

  var _super = _createSuper(Question);

  function Question() {
    _classCallCheck(this, Question);

    return _super.apply(this, arguments);
  }

  _createClass(Question, [{
    key: "id",
    get: function get() {
      return this._id;
    }
  }, {
    key: "status",
    get: function get() {
      return this.props.status;
    }
  }, {
    key: "description",
    get: function get() {
      return this.props.description;
    }
  }, {
    key: "files",
    get: function get() {
      return this.props.files;
    }
  }, {
    key: "images",
    get: function get() {
      return this.props.images;
    }
  }, {
    key: "type",
    get: function get() {
      return this.props.type;
    }
  }, {
    key: "sectionId",
    get: function get() {
      return this.props.sectionId;
    }
  }, {
    key: "formId",
    get: function get() {
      return this.props.formId;
    }
  }, {
    key: "formReleaseId",
    get: function get() {
      return this.props.formId;
    } // NOTE: This is the score value, not the score object -> legacy, so I created scoreV2

  }, {
    key: "score",
    get: function get() {
      return this.props.score.value;
    }
  }, {
    key: "scoreV2",
    get: function get() {
      return this.props.score;
    }
  }, {
    key: "explanation",
    get: function get() {
      return this.props.explanation;
    }
  }, {
    key: "index",
    get: function get() {
      return this.props.index;
    }
  }, {
    key: "nextIndex",
    get: function get() {
      return this.props.nextIndex;
    }
  }, {
    key: "previousQuestionId",
    get: function get() {
      return this.props.previousQuestionId;
    }
  }, {
    key: "nextQuestionId",
    get: function get() {
      return this.props.nextQuestionId;
    }
  }, {
    key: "answers",
    get: function get() {
      return this.props.answers;
    }
  }, {
    key: "subQuestions",
    get: function get() {
      return this.props.subQuestions;
    }
  }, {
    key: "audioFile",
    get: function get() {
      return this.props.audioFile;
    }
  }, {
    key: "headingId",
    get: function get() {
      return this.props.headingId;
    }
  }, {
    key: "nextHeadingId",
    get: function get() {
      return this.props.nextHeadingId;
    }
  }, {
    key: "aiChangeType",
    get: function get() {
      return this.props.aiChangeType;
    }
  }, {
    key: "titleIndex",
    get: function get() {
      var _this$props$index;

      return this.props.nextIndex && this.props.nextIndex - this.props.index > 1 ? "".concat(this.props.index, " - ").concat(this.props.nextIndex - 1) : (_this$props$index = this.props.index) === null || _this$props$index === void 0 ? void 0 : _this$props$index.toString();
    }
  }, {
    key: "descriptionWithEmptyOrImage",
    get: function get() {
      // Basic search and replace for image tag (not secure and limited)
      var replacedText = this.props.description.replace(/<img\s+[^>]*>/g, ' [Image] '); // Check if text contains any characters (including whitespace)

      var hasContent = replacedText.trim() !== '';
      var hasEmpty = replacedText.trim() === '<p><br></p>'; // Handle different cases

      if (hasContent) {
        return replacedText; // Display text with "(Image)" for image tag
      } else if (hasEmpty) {
        return '[No description]'; // Replace empty text with "(no description)"
      } else {
        return this.props.description;
      }
    }
  }, {
    key: "toJsonObject",
    value: function toJsonObject() {
      return _objectSpread(_objectSpread({}, this.props), {}, {
        description: this.renderMarkdown(this.props.description),
        files: this.props.files.map(function (file) {
          return file.toJsonObject();
        }),
        audioFile: this.audioFile ? this.audioFile.toJsonObject() : undefined
      });
    }
  }, {
    key: "createDefault",
    value: function createDefault(description) {
      throw new Error('Create question has not implemented yet');
    }
  }, {
    key: "cloneNewType",
    value: function cloneNewType(toQuestionType, defaultDescription) {
      var newQuestionProps = {
        id: this.id.toString(),
        description: this.props.description,
        formId: this.props.formId,
        sectionId: this.props.sectionId,
        score: this.props.score,
        explanation: this.props.explanation,
        previousQuestionId: this.props.previousQuestionId,
        files: _toConsumableArray(this.props.files),
        audioFile: this.props.audioFile,
        type: toQuestionType,
        status: QuestionStatus.New,
        headingId: this.props.headingId,
        nextHeadingId: this.props.nextHeadingId
      };
      return this.cloneExtendedProps(this, newQuestionProps, defaultDescription);
    }
  }, {
    key: "cloneExtendedProps",
    value: function cloneExtendedProps(question, newQuestionProps, defaultDescription) {
      return Result.fail('Not implemented');
    }
  }, {
    key: "clone",
    value: function clone() {
      var newQuestionProps = {
        id: this.id.toString(),
        description: this.props.description,
        formId: this.props.formId,
        sectionId: this.props.sectionId,
        score: this.props.score,
        explanation: this.props.explanation,
        previousQuestionId: this.props.previousQuestionId,
        files: _toConsumableArray(this.props.files),
        audioFile: this.props.audioFile,
        type: this.props.type,
        status: this.props.status,
        headingId: this.props.headingId,
        nextHeadingId: this.props.nextHeadingId,
        index: this.props.index,
        nextIndex: this.props.nextIndex
      };
      return this.cloneExtendedProps(this, newQuestionProps).getValue();
    }
  }, {
    key: "activate",
    value: function activate() {
      this.props.status = QuestionStatus.Activate;
      return Result.ok();
    }
  }, {
    key: "markAsNew",
    value: function markAsNew() {
      this.props.status = QuestionStatus.New;
      return Result.ok();
    }
  }, {
    key: "isEssayQuestion",
    value: function isEssayQuestion() {
      return this.type === QuestionType.Essay;
    }
  }, {
    key: "isFillInBlankQuestion",
    value: function isFillInBlankQuestion() {
      return this.type === QuestionType.FillInBlank;
    }
  }, {
    key: "isMatchingQuestion",
    value: function isMatchingQuestion() {
      return this.type === QuestionType.Matching;
    }
  }, {
    key: "updateDescription",
    value: function updateDescription(description) {
      this.props.description = description;
      return Result.ok();
    }
  }, {
    key: "updateScore",
    value: function updateScore(value) {
      this.props.score = Score.create(value).getValue();
      return Result.ok();
    }
  }, {
    key: "updateExplanation",
    value: function updateExplanation(explanation) {
      this.props.explanation = explanation;
      return Result.ok();
    }
  }, {
    key: "updateFiles",
    value: function updateFiles(files) {
      this.props.files = files;
      return Result.ok();
    }
  }, {
    key: "updateImages",
    value: function updateImages(images) {
      this.props.images = images;
      return Result.ok();
    }
  }, {
    key: "addIndex",
    value: function addIndex(index) {
      this.props.index = index;
      return Result.ok();
    }
  }, {
    key: "addNextIndex",
    value: function addNextIndex(index) {
      this.props.nextIndex = index;
      return Result.ok();
    }
  }, {
    key: "updatePreviousQuestionId",
    value: function updatePreviousQuestionId(id) {
      this.props.previousQuestionId = id;
      return Result.ok();
    }
  }, {
    key: "updateHeadingId",
    value: function updateHeadingId(headingId) {
      this.props.headingId = headingId;
      return Result.ok();
    }
  }, {
    key: "updateNextHeadingId",
    value: function updateNextHeadingId(nextHeadingId) {
      this.props.nextHeadingId = nextHeadingId;
      return Result.ok();
    }
  }, {
    key: "updateSectionId",
    value: function updateSectionId(sectionId) {
      this.props.sectionId = sectionId;
      return Result.ok();
    }
  }, {
    key: "renderMarkdown",
    value: function renderMarkdown(content) {
      var md = new MarkdownIt();
      return Result.ok(md.render(content));
    }
  }, {
    key: "addFile",
    value: function addFile(file) {
      if (!file) {
        return new BadInputError('File cannot be null when adding new file');
      }

      this.props.files.push(file);
      return Result.ok();
    }
  }, {
    key: "deleteFile",
    value: function deleteFile(id) {
      var foundFile = this.props.files.find(function (f) {
        return f.id.toString() === id;
      });

      if (!foundFile) {
        return new NotFoundError('File does not existed');
      }

      this.props.files = this.props.files.filter(function (f) {
        return f.id.toString() !== id;
      });
      return Result.ok();
    }
  }, {
    key: "updateAnswer",
    value: function updateAnswer(answer) {
      if (!answer) {
        return new BadInputError('Update answer cannot be null or empty');
      }

      var hasAnswerNotExisted = this.props.answers.find(function (a) {
        return a.id.toString() === answer.id.toString();
      }) === undefined;

      if (hasAnswerNotExisted) {
        return new NotFoundError('Answer does not existed');
      }

      return Result.ok();
    }
  }, {
    key: "addAudioFile",
    value: function addAudioFile(audioFile) {
      if (!audioFile) {
        return new BadInputError('Audio file cannot be null when adding new audio file');
      }

      this.props.audioFile = audioFile;
      return Result.ok();
    }
  }, {
    key: "deleteAudioFile",
    value: function deleteAudioFile() {
      this.props.audioFile = null; // null indicates that the audio file is deleted

      return Result.ok();
    }
  }, {
    key: "updateAudioFile",
    value: function updateAudioFile(audioFile) {
      this.props.audioFile = audioFile;
      return Result.ok();
    }
  }, {
    key: "deActivate",
    value: function deActivate() {
      this.props.status = QuestionStatus.Deactivate;
      return Result.ok();
    }
  }, {
    key: "getTruncatedText",
    value: function getTruncatedText() {
      var maxLength = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 25;
      var regex = /<[^>]*>/g;
      var textWithoutTags = this.descriptionWithEmptyOrImage.replace(regex, '');
      return textWithoutTags.substring(0, maxLength) + (textWithoutTags.length > maxLength ? '...' : '');
    } // v2

  }, {
    key: "toBaseJson",
    value: function toBaseJson() {
      return _objectSpread(_objectSpread({}, this.props), {}, {
        score: this.scoreV2.value,
        files: this.props.files.map(function (file) {
          return file.toJsonObject();
        }),
        audioFile: this.audioFile ? this.audioFile.toJsonObject() : undefined
      });
    }
  }], [{
    key: "fromJsonBase",
    value: function fromJsonBase(data) {
      var files = data.files;
      var mappedFiles = []; // eslint-disable-next-line no-loops/no-loops

      var _iterator = _createForOfIteratorHelper(files),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var file = _step.value;
          var fileOrError = File.fromJson(file);

          if (fileOrError.isFailure) {
            return Result.fail(fileOrError.error);
          }

          mappedFiles.push(fileOrError.getValue());
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      var audioFile = data.audioFile ? AudioFile.fromJson(data.audioFile).getValue() : undefined;
      return this.createBaseProps(_objectSpread(_objectSpread({}, data), {}, {
        score: data.score ? Score.create(data.score).getValue() : Score["default"],
        files: mappedFiles,
        status: QuestionStatus.Activate,
        audioFile: audioFile
      }));
    }
  }, {
    key: "createBaseProps",
    value: function createBaseProps(props) {
      var _props$previousQuesti, _props$files, _props$score;

      var resultOrError = this.validate(props);

      if (resultOrError.isFailure) {
        var _resultOrError$error;

        return Result.fail((_resultOrError$error = resultOrError.error) !== null && _resultOrError$error !== void 0 ? _resultOrError$error : 'Error');
      }

      var defaultProps = _objectSpread(_objectSpread({}, props), {}, {
        previousQuestionId: (_props$previousQuesti = props.previousQuestionId) !== null && _props$previousQuesti !== void 0 ? _props$previousQuesti : PreviousQuestionId.none.id.toString(),
        files: (_props$files = props.files) !== null && _props$files !== void 0 ? _props$files : [],
        score: (_props$score = props.score) !== null && _props$score !== void 0 ? _props$score : Score["default"]
      });

      return Result.ok(defaultProps);
    }
  }, {
    key: "validate",
    value: function validate(props) {
      var guardResult = Guard.againstNullOrUndefined(props, 'Question Props');

      if (!guardResult.succeeded) {
        var _guardResult$message;

        return Result.fail((_guardResult$message = guardResult.message) !== null && _guardResult$message !== void 0 ? _guardResult$message : 'Error');
      }

      var guardCollections = [{
        argument: props.sectionId,
        argumentName: 'Section Id'
      }, {
        argument: props.formId,
        argumentName: 'FormId'
      }];
      var guardCollectionResult = Guard.againstNullOrUndefinedBulk(guardCollections);

      if (!guardCollectionResult.succeeded) {
        return Result.fail(guardCollectionResult.message);
      }

      return Result.ok();
    }
  }]);

  return Question;
}(Entity);

_defineProperty(Question, "defaultScore", 0.5);